import { Component } from "../component"
import { scrollLoop } from "../helpers/scroll-loop"
import { iterable } from "../helpers/iterable"

export class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isNavigationBarHover: false,
      isNavigationHover: false,
      currentNavigationItemIndex: null,
      isTouchDevice: false,
    }

    this.dynamicClasses = {
      sticky: "-sticky",
      navigationVisible: "-navigation-visible",
      hasSubmenu: "-has-submenu",
      submenuVisible: "-submenu-visible",
      active: "-active",
      searchModalVisible: "-search-modal-visible",
    }
  }

  ui() {
    return {
      navigation: ".header-navigation",
      navigationBarLinks: ".header-navigation-bar-link",
      navigationSearch: ".header-navigation-search",
      navigationSearchInput: ".header-navigation-search-input",
      menuSwitcher: ".header-menu-switcher",
      navigationItems: ".header-navigation-item",
      navigationLinks: ".header-navigation-link",
      submenus: ".header-navigation-submenu",
      submenuGroups: ".header-navigation-submenu-group",
      submenuItems: ".header-navigation-submenu-item",
      submenuLinks: ".header-navigation-submenu-link",
      toolbarSearchLink: ".header-toolbar-link-search",
      searchModalForm: ".header-search-modal-form",
      sarchModalInput: ".header-search-modal-input",
    }
  }

  detectTouchDevice() {
    this.state.isTouchDevice =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
  }

  handleScroll(position) {
    const { sticky, navigationVisible, searchModalVisible } =
      this.dynamicClasses
    const stickyBreakpoint = window.innerWidth >= 1024 ? 70 : 1
    const isSticky = position >= stickyBreakpoint
    const stickyProgress = isSticky ? 1 : position / stickyBreakpoint

    if (isSticky && !this.$el.parentElement.classList.contains(sticky)) {
      this.$el.parentElement.classList.add(sticky)
    } else if (!isSticky && this.$el.parentElement.classList.contains(sticky)) {
      this.$el.parentElement.classList.remove(sticky)
    }

    if (window.innerWidth >= 1024) {
      if (position <= stickyBreakpoint + 100) {
        this.$el.parentElement.style.setProperty(
          "--sticky-progress",
          stickyProgress
        )
      }

      if (this.$el.parentElement.classList.contains(navigationVisible)) {
        this.hideNavigation()
      }

      if (this.$el.parentElement.classList.contains(searchModalVisible)) {
        this.toggleSearchModal()
      }
    }
  }

  toggleNavigationItem() {
    const { navigationItems } = this.$ui
    const { active } = this.dynamicClasses

    iterable(navigationItems).forEach((item, index) => {
      item.classList.toggle(
        active,
        index === this.state.currentNavigationItemIndex
      )
    })
  }

  hideNavigation() {
    const { submenuItems, navigationBarLinks } = this.$ui
    const { navigationVisible, active, hasSubmenu } = this.dynamicClasses

    this.toggleNavigationItem()
    this.$el.parentElement.classList.remove(navigationVisible)
    iterable(submenuItems).forEach((item) => {
      item.classList.remove(active)
    })
    iterable(navigationBarLinks).forEach((link) => {
      if (link.parentElement.classList.contains(hasSubmenu)) {
        link.parentElement.classList.remove(active)
      }
    })
    this.state.currentNavigationItemIndex = null
  }

  toggleSearchModal() {
    const { toolbarSearchLink, sarchModalInput } = this.$ui
    const { searchModalVisible, active } = this.dynamicClasses
    const el = this.$el.parentElement

    el.classList.toggle(searchModalVisible)
    toolbarSearchLink.classList.toggle(active)

    if (el.classList.contains(searchModalVisible)) {
      setTimeout(() => {
        sarchModalInput.focus()
      }, 250)
    } else {
      setTimeout(() => {
        sarchModalInput.value = ""
        sarchModalInput.parentElement.querySelector(
          ".predictive-search-results"
        ).style.display = "none"
      }, 250)
    }
  }

  attachEvents() {
    const {
      navigation,
      navigationBarLinks,
      navigationSearch,
      navigationSearchInput,
      menuSwitcher,
      navigationItems,
      navigationLinks,
      submenuGroups,
      submenuItems,
      submenuLinks,
      toolbarSearchLink,
      searchModalForm,
      sarchModalInput,
    } = this.$ui
    const {
      navigationVisible,
      hasSubmenu,
      submenuVisible,
      active,
      searchModalVisible,
    } = this.dynamicClasses

    if (window.innerWidth >= 1024) {
      iterable(navigationBarLinks).forEach((link, index) => {
        if (!link.parentElement.classList.contains(hasSubmenu)) {
          return
        }

        link.addEventListener("click", (e) => {
          if (index === this.state.currentNavigationItemIndex) {
            this.state.currentNavigationItemIndex = null
            this.$el.parentElement.classList.remove(navigationVisible)
            link.closest("li").classList.remove(active)
            iterable(submenuItems).forEach((item) => {
              item.classList.remove(active)
            })
          } else {
            this.state.currentNavigationItemIndex = index
            this.$el.parentElement.classList.add(navigationVisible)
            link
              .closest("li")
              .parentElement.querySelectorAll("li.-has-submenu")
              .forEach((li) => {
                li.classList.remove(active)
              })
            link.closest("li").classList.add(active)
          }
          this.toggleNavigationItem()

          e.preventDefault()
        })
      })

      iterable(submenuGroups).forEach((group) => {
        const links = group.querySelectorAll(".header-navigation-submenu-link")
        iterable(links).forEach((link, linkIndex) => {
          if (this.state.isTouchDevice) {
            return
          }

          link.addEventListener("mouseenter", () => {
            const submenuItems = link.closest("ul").children
            const videoThumbnail = link.parentElement.querySelector("video")

            iterable(submenuLinks).forEach((link) => {
              link.parentElement.classList.remove(active)
              const video = link.parentElement.querySelector("video")
              if (video && !video.paused) {
                video.pause()
              }
            })
            submenuItems[linkIndex].classList.add(active)

            if (videoThumbnail && videoThumbnail.paused) {
              videoThumbnail.currentTime = 0
              videoThumbnail.play()
            }
          })
        })
      })

      toolbarSearchLink.addEventListener("click", (e) => {
        this.toggleSearchModal()
        e.preventDefault()
      })

      searchModalForm.addEventListener("submit", (e) => {
        if (sarchModalInput.value.length === 0) {
          e.preventDefault()
        }
      })

      window.addEventListener("keyup", (e) => {
        if (
          e.code === "Escape" &&
          this.$el.parentElement.classList.contains(searchModalVisible)
        ) {
          this.toggleSearchModal()
        }
      })

      document.body.addEventListener("click", (e) => {
        if (
          this.$el.parentElement.classList.contains(navigationVisible) &&
          !e.target.closest(".header-navigation-bar-link")
        ) {
          this.hideNavigation()
        }

        if (
          this.$el.parentElement.classList.contains(searchModalVisible) &&
          !e.target.closest(".header-search-modal-input") &&
          !e.target.closest(".header-search-modal-button") &&
          !e.target.closest(".header-toolbar-link-search")
        ) {
          this.toggleSearchModal()
        }
      })
    } else if (navigationSearchInput) {
      menuSwitcher.addEventListener("click", () => {
        this.$el.parentElement.classList.toggle(navigationVisible)

        if (!this.$el.parentElement.classList.contains(navigationVisible)) {
          setTimeout(() => {
            navigationSearchInput.value = ""
            navigationSearchInput.parentElement.querySelector(
              ".predictive-search-results"
            ).style.display = "none"
            navigationItems.forEach((item) => {
              item.classList.remove(submenuVisible)
              const submenu = item.querySelector("[data-height]")
              if (submenu) {
                submenu.style.height = 0
              }
            })
          }, 500)
        }
      })

      iterable(navigationLinks).forEach((link) => {
        link.addEventListener("click", (e) => {
          if (link.parentElement.classList.contains(hasSubmenu)) {
            const submenu = link.nextElementSibling
            e.preventDefault()
            submenu.style.height = link.parentElement.classList.contains(
              submenuVisible
            )
              ? 0
              : submenu.dataset.height
            link.parentElement.classList.toggle(submenuVisible)
          }
        })
      })

      navigationSearch.addEventListener("submit", (e) => {
        if (navigationSearchInput.value.length === 0) {
          e.preventDefault()
        }
      })
    }
  }

  calculateSubmenuHeights() {
    const { submenus } = this.$ui

    iterable(submenus).forEach((submenu) => {
      submenu.style.height = "auto"
      submenu.dataset.height = `${submenu.offsetHeight}px`
      submenu.removeAttribute("style")
    })
  }

  created() {
    const { navigationVisible } = this.dynamicClasses

    this.detectTouchDevice()

    this.attachEvents()

    scrollLoop(() => {
      this.handleScroll(window.pageYOffset)
    })

    if (window.innerWidth < 1024) {
      this.calculateSubmenuHeights()
    }

    if (window.innerWidth < 1024) {
      document.body.addEventListener(
        "touchmove",
        (e) => {
          if (
            this.$el.parentElement.classList.contains(navigationVisible) &&
            !e.target.closest(".header-navigation-submenu")
          ) {
            e.preventDefault()
          }
        },
        {
          passive: false,
        }
      )
    }
  }
}
